/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReferrerResponse
 */
export interface ReferrerResponse {
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    fullname: string;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    profileId: string;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof ReferrerResponse
     */
    phoneNumber?: string;
}

/**
 * Check if a given object implements the ReferrerResponse interface.
 */
export function instanceOfReferrerResponse(value: object): value is ReferrerResponse {
    if (!('fullname' in value) || value['fullname'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('profileId' in value) || value['profileId'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    return true;
}

export function ReferrerResponseFromJSON(json: any): ReferrerResponse {
    return ReferrerResponseFromJSONTyped(json, false);
}

export function ReferrerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferrerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'fullname': json['fullname'],
        'email': json['email'],
        'profileId': json['profileId'],
        'accountId': json['accountId'],
        'phoneNumber': json['phoneNumber'] == null ? undefined : json['phoneNumber'],
    };
}

export function ReferrerResponseToJSON(value?: ReferrerResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'fullname': value['fullname'],
        'email': value['email'],
        'profileId': value['profileId'],
        'accountId': value['accountId'],
        'phoneNumber': value['phoneNumber'],
    };
}

